import Vue from "vue";

let container;

export default function getInnerText(node) {
  if (!node) return "";

  if (!container) {
    container = document.createElement("div");
    container.setAttribute("aria-hidden", "true");
    document.body.appendChild(container);
  }

  const vm = new Vue({
    render(h) {
      return h("div", node);
    },
  });

  container.appendChild(vm.$mount().$el);
  const text = container.innerText;
  vm.$destroy();
  container.innerHTML = "";

  return text;
}
